﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpTopNavBar = void 0;
const gs = require("@ivanlog/gs");
const com = require("./tmpls");
class UpTopNavBar extends com.TopNavBar {
    constructor(app) {
        super();
        this.app = app;
        this._body = gs.q('body').first;
    }
    show() {
        this._body.addClass('with_top_bar');
        super.show();
    }
    hide() {
        this._body.removeClass('with_top_bar');
        super.hide();
    }
}
exports.UpTopNavBar = UpTopNavBar;
//# sourceMappingURL=UpTopNavBar.js.map